import Vue from "vue";

const Facebook = {
  enable() {
    Vue.$log.info("fb enable");
    // eslint-disable-next-line no-unused-expressions,wrap-iife
    !(function (f, b, e, v) {
      if (f.fbq) return;
      const n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      const t = b.createElement(e);
      t.async = !0;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
  },
  wait() {
    return !!window.fbq;
  },
  init() {
    window.fbq("init", "1649877658563488");
  },
  simulacion() {
    window.fbq("track", "PageView", { content_type: "Plazo Fijo No Clientes" });
    window.fbq("track", "ViewContent", {
      content_type: "Plazo Fijo No Clientes",
    });
  },
  noCliente() {
    window.fbq("track", "AddToWhishlist", {
      content_type: "Plazo Fijo No Clientes",
    });
  },
  cliente() {
    window.fbq("track", "ViewContent", {
      content_type: "Ya sos cliente Plazo Fijo",
    });
  },
  datosPersonales() {
    window.fbq("track", "Lead", { content_type: "Plazo Fijo No Clientes" });
  },
  datosLaborales() {
    window.fbq("track", "AddtoCart", {
      content_type: "Plazo Fijo No Clientes",
    });
  },
  activity() {
    window.fbq("track", "InitiateCheckout", {
      content_type: "Plazo Fijo No Clientes",
    });
  },
  datosCuenta() {
    window.fbq("track", "Suscribe", { content_type: "Plazo Fijo No Clientes" });
  },
  confirmacion() {
    window.fbq("track", "CompleteRegistration", {
      content_type: "Plazo Fijo No Clientes",
    });
  },
  thank() {
    window.fbq("track", "Purchase", { content_type: "Plazo Fijo No Clientes" });
  },
};

export default Facebook;
